<template>
    <div class="voteAdd">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>投票</el-breadcrumb-item>
            <el-breadcrumb-item>创建项目</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="vote-add-box">
            <el-form :model="addVoteForm" :rules="validateRules" ref="addVoteForm" label-width="100px" class="addVoteForm">
                <el-form-item label="标题" prop="vote_name">
                    <el-input v-model="addVoteForm.vote_name" placeholder="请填写投票标题"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="vote_content">
                    <el-input type="textarea" v-model="addVoteForm.vote_content" placeholder="请填写投票描述"></el-input>
                </el-form-item>
                <el-form-item label="焦点图" prop="bgimg">
                    <el-input v-model="addVoteForm.bgimg" placeholder="请填写焦点图（尺寸2：1）链接"></el-input>
                </el-form-item>
                <el-form-item label="起止时间" prop="vote_start_end_time">
                    <el-date-picker v-model="addVoteForm.vote_start_end_time" type="datetimerange" :editable="false" :picker-options="pickerOptions" placeholder="选择时间范围" align="right"></el-date-picker>
                </el-form-item>
                <el-form-item class="is_share_box" label="自定义分享" prop="is_share">
                    <el-switch @change="changeIsShareFlag" v-model="addVoteForm.is_share" on-color="#13ce66" off-color="#ff4949" on-value="1" off-value="0"></el-switch>
                </el-form-item>
                <template v-if="addVoteForm.is_share === '1'">
                    <el-form-item label="分享标题" prop="share_title">
                        <el-input v-model="addVoteForm.share_title" placeholder="请填写分享标题"></el-input>
                    </el-form-item>
                    <el-form-item label="分享描述" prop="share_content">
                        <el-input v-model="addVoteForm.share_content" placeholder="请填写分享描述"></el-input>
                    </el-form-item>
                    <el-form-item label="分享图" prop="share_img">
                        <el-input v-model="addVoteForm.share_img" placeholder="请填写分享图链接"></el-input>
                    </el-form-item>
                </template>
                <el-form-item>
                    <el-button type="primary" @click="addVote('addVoteForm')">立即创建</el-button>
                    <el-button @click="clearVoteData()">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="vote-preview-box">
                <div class="header-image">
                    <img v-if="addVoteForm.bgimg" :src="addVoteForm.bgimg" >
                </div>
                <div class="description" v-if="addVoteForm.vote_content !== null && addVoteForm.vote_content !== ''">
                    <span class="desc-content">{{addVoteForm.vote_content}}</span>
                </div>
                <div class="content">
                    <div class="go-list-btn">查看排名</div>
                    <div class="option-list">
                        <img src="http://tstatic.toptest.yidianzixun.com.ks3-cn-beijing.ksyun.com/public/files/demo1497505528343.png" >
                        <img src="http://tstatic.toptest.yidianzixun.com.ks3-cn-beijing.ksyun.com/public/files/demo1497505528343.png" >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "specialAdd",
    data() {
        return {
            addVoteForm: {
                vote_name: null,
                vote_content: null,
                vote_user: null,
                vote_start_end_time: null,
                bgimg: null,
                is_share: '0',
                share_title: null,
                share_content: null,
                share_img: null
            },
            validateRules: {
                vote_name: [
                    { required: true, message: '请填写投票标题', trigger: 'blur' }
                ],
                vote_content: [
                    { required: true, message: '请填写投票描述', trigger: 'blur' }
                ],
                bgimg: [
                    { required: true, message: '请填写焦点图链接', trigger: 'blur' }
                ],
                vote_start_end_time: [
                    { type: 'array', required: true, message: '请选择投票起止时间', trigger: 'blur' }
                ],
                is_share: [
                    { required: true, message: '请设置选择自定义分享', trigger: 'blur' }
                ]
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            }
        };
    },
    mounted(){
        this._init();
    },
    methods: {
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        addVote(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$http.post(CONFIG.HOST + '/voteSystem/vote/addVote', {
                vote_name: this.addVoteForm.vote_name,
                vote_content: this.addVoteForm.vote_content,
                vote_user: this.addVoteForm.vote_user,
                bgimg: this.addVoteForm.bgimg,
                vote_start_time: (+new Date(this.addVoteForm.vote_start_end_time[0])),
                vote_end_time: (+new Date(this.addVoteForm.vote_start_end_time[1])),
                is_share: parseInt(this.addVoteForm.is_share),
                share_title: this.addVoteForm.share_title,
                share_content: this.addVoteForm.share_content,
                share_img: this.addVoteForm.share_img
            }).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: `【营销平台】名称为${this.addVoteForm.vote_name}的投票创建成功`
                    });
                    router.push({
                        name: 'voteList'
                    });
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        clearVoteData(){
            for (let key in this.addVoteForm) {
                if (key !== 'vote_user') {
                    this.addVoteForm[key] = null;
                }
            }
        },
        changeIsShareFlag(data){
            console.log(typeof data);
        },
        _init() {
            let $route = this.$route;
            this.addVoteForm.vote_user = Base64.decode($route.params.userId);
        }
    }
};
</script>
<style lang="less">
    .voteAdd{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .vote-add-box{
            width: 980px;
            position: relative;
            left: 0;
            top: 0;
            .is_share_box{
                .el-form-item__content{
                    width: 60px;
                }
            }
            .addVoteForm{
                width: 440px;
                
                position: absolute;
                left: 0;
                top: 0;

                .selectForm{
                    width: 100%;
                }
            }
            .vote-preview-box{
                width: 360px;
                height: 540px;
                border: 1px solid #bfcbd9;
                border-radius: 6px;

                overflow-y: auto;

                position: absolute;
                left: 550px;
                top: 0;

                .header-image{
                    width: 100%;
                    display: block;
                    img{
                        width: 100%;
                    }
                }
                .description{
                    padding: 0 11px;
                    font-size: 10px;
                    text-align: left;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #ccc;
                    padding-bottom: 10px;
                    .desc-icon{
                        color: #fff;
                        background: #0c9aee;
                        display: inline-flex;
                        padding-left: 2px;
                        padding-right: 2px;
                    }
                    .desc-content{

                    }
                }
                .content{
                    width: 100%;
                    .go-list-btn{
                        margin: 0 auto;

                        width: 94%;
                        height: 30px;
                        line-height: 30px;
                        color: #ffffff;
                        background: #f34c3f;
                        border-radius: 5px;
                    }
                    .option-list{
                        width: 94%;
                        margin: 0 auto;
                        margin-top: 10px;
                    }
                    img{
                        width: 100%;
                    }
                }
            }
        }
    }  
</style>


// WEBPACK FOOTER //
// Add.vue?2fa7df90